import React, { useRef, useState } from "react";
import "./Contact.css";
import contact_logo from "../../assets/contact/contact_logo.png";
import hive_page_logo from "../../assets/allpages/hive_page_logo.png";
import contact_right from "../../assets/contact/bg_photo.png";

const Contact = () => {
  const form = useRef();
  const [responseMessage, setResponseMessage] = useState("");
  const [isSending, setIsSending] = useState(false);

  const contactRef = useRef(null);
  const leftContactTopRef = useRef(null);
  const rightContactLogoRef = useRef(null);
  const contactRightPhotoRef = useRef(null);
  const inputsRef = useRef(null);
  const textAreaRef = useRef(null);
  const submitRef = useRef(null);

  const sendWithFormSubmit = async (formData, senderEmail) => {
    const fallbackData = new FormData();
    formData.forEach((value, key) => fallbackData.append(key, value));

    if (senderEmail) {
      fallbackData.append("_replyto", String(senderEmail));
    }

    const response = await fetch(
      "https://formsubmit.co/ajax/office@hiveteam.dev",
      {
        method: "POST",
        headers: {
          Accept: "application/json",
        },
        body: fallbackData,
      },
    );

    const result = await response.json();
    if (!response.ok || result.success === "false") {
      throw new Error(result.message || "FormSubmit failed");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSending(true);
    setResponseMessage("");

    const formData = new FormData(form.current);
    const senderEmail = formData.get("contact_email");
    const web3FormsKey = process.env.REACT_APP_WEB3FORMS_ACCESS_KEY;

    try {
      if (web3FormsKey) {
        const payload = {
          access_key: web3FormsKey,
          name: String(formData.get("name") || ""),
          email: String(senderEmail || ""),
          phone: String(formData.get("phone") || ""),
          subject: String(formData.get("subject") || ""),
          message: String(formData.get("message") || ""),
          from_name: "HiveTeam Contact Form",
          botcheck: "",
        };

        const response = await fetch("https://api.web3forms.com/submit", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify(payload),
        });

        const result = await response.json();

        if (!response.ok || !result.success) {
          throw new Error(result.message || "Web3Forms failed");
        }
      } else {
        await sendWithFormSubmit(formData, senderEmail);
      }

      setResponseMessage("Message sent successfully!");
      form.current.reset();
    } catch (error) {
      try {
        await sendWithFormSubmit(formData, senderEmail);
        setResponseMessage("Message sent successfully!");
        form.current.reset();
      } catch (fallbackError) {
        setResponseMessage(
          "Delivery failed. Please retry in 1-2 minutes or contact us at office@hiveteam.dev.",
        );
      }
    } finally {
      setIsSending(false);
    }
  };

  return (
    <div className="contact_page" id="contact" ref={contactRef}>
      <img
        className="contact_poza_right"
        src={contact_right}
        alt="Contact HiveTeam"
        ref={contactRightPhotoRef}
      />

      <div className="contact_container">
        <div className="contact_top">
          <div className="left_contact_top" ref={leftContactTopRef}>
            <img src={contact_logo} alt="Contact HiveTeam" />
            <p>
              Our team is a dynamic and diverse group of talented professionals
              who each bring a unique set of skills and experiences. Below is a
              detailed description of each team member:
            </p>
          </div>
          <img
            className="hive_allpages"
            src={hive_page_logo}
            alt="HiveTeam logo"
            ref={rightContactLogoRef}
          />
        </div>

        <div className="contact_center">
          <form ref={form} onSubmit={handleSubmit} className="inputs_part">
            <input
              type="hidden"
              name="_subject"
              value="HiveTeam Contact Form"
            />
            <input type="hidden" name="_captcha" value="false" />
            <input type="hidden" name="_template" value="table" />
            <div className="inputs_part">
              <div className="inputs" ref={inputsRef}>
                <div className="input_cont">
                  <h1>Name</h1>
                  <input
                    type="text"
                    name="name"
                    placeholder="Office Hive Team"
                    required
                  />
                  <svg
                    width="25"
                    height="25"
                    viewBox="0 0 25 25"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8 7C8 9.481 10.019 11.5 12.5 11.5C14.981 11.5 17 9.481 17 7C17 4.519 14.981 2.5 12.5 2.5C10.019 2.5 8 4.519 8 7ZM20.5 21.5H21.5V20.5C21.5 16.641 18.359 13.5 14.5 13.5H10.5C6.64 13.5 3.5 16.641 3.5 20.5V21.5H20.5Z"
                      fill="white"
                    />
                  </svg>
                </div>

                <div className="input_cont">
                  <h1>Email</h1>
                  <input
                    type="email"
                    name="contact_email"
                    placeholder="office@hiveteam.dev"
                    required
                  />
                  <svg
                    width="21"
                    height="17"
                    viewBox="0 0 21 17"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M17.5 0.5H3.5C2.70435 0.5 1.94129 0.81607 1.37868 1.37868C0.81607 1.94129 0.5 2.70435 0.5 3.5V13.5C0.5 14.2956 0.81607 15.0587 1.37868 15.6213C1.94129 16.1839 2.70435 16.5 3.5 16.5H17.5C18.2956 16.5 19.0587 16.1839 19.6213 15.6213C20.1839 15.0587 20.5 14.2956 20.5 13.5V3.5C20.5 2.70435 20.1839 1.94129 19.6213 1.37868C19.0587 0.81607 18.2956 0.5 17.5 0.5ZM16.83 2.5L10.5 7.25L4.17 2.5H16.83ZM17.5 14.5H3.5C3.23478 14.5 2.98043 14.3946 2.79289 14.2071C2.60536 14.0196 2.5 13.7652 2.5 13.5V3.75L9.9 9.3C10.0731 9.4298 10.2836 9.5 10.5 9.5C10.7164 9.5 10.9269 9.4298 11.1 9.3L18.5 3.75V13.5C18.5 13.7652 18.3946 14.0196 18.2071 14.2071C18.0196 14.3946 17.7652 14.5 17.5 14.5Z"
                      fill="white"
                    />
                  </svg>
                </div>

                <div className="input_cont">
                  <h1>Numar de telefon</h1>
                  <input type="text" name="phone" placeholder="760 560 346" />
                  <svg
                    width="21"
                    height="21"
                    viewBox="0 0 21 21"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M15.9 20.5001C11.8173 20.4948 7.90331 18.8706 5.0164 15.9837C2.12949 13.0968 0.50529 9.1828 0.5 5.10011C0.5 3.88011 0.98464 2.71008 1.84731 1.84742C2.70998 0.984755 3.88 0.500115 5.1 0.500115C5.35834 0.498145 5.61625 0.521594 5.87 0.570114C6.11531 0.606414 6.35647 0.666705 6.59 0.750115C6.75425 0.807745 6.90061 0.907245 7.01461 1.03878C7.12861 1.17032 7.2063 1.32934 7.24 1.50011L8.61 7.50011C8.6469 7.66297 8.6425 7.83249 8.5971 7.99319C8.5516 8.15389 8.46671 8.30066 8.35 8.42011C8.22 8.5601 8.21 8.5701 6.98 9.2101C7.96499 11.371 9.6932 13.1063 11.85 14.1001C12.5 12.8601 12.51 12.8501 12.65 12.7201C12.7694 12.6034 12.9162 12.5185 13.0769 12.473C13.2376 12.4276 13.4071 12.4232 13.57 12.4601L19.57 13.8301C19.7353 13.8685 19.8881 13.9483 20.0141 14.062C20.14 14.1757 20.235 14.3196 20.29 14.4801C20.3744 14.7175 20.438 14.9617 20.48 15.2101C20.5202 15.4614 20.5403 15.7156 20.54 15.9701C20.5216 17.1849 20.0233 18.343 19.154 19.1918C18.2847 20.0405 17.1149 20.5108 15.9 20.5001Z"
                      fill="white"
                    />
                  </svg>
                </div>

                <div className="input_cont">
                  <h1>Subiect</h1>
                  <input
                    type="text"
                    name="subject"
                    placeholder="Your Project"
                    required
                  />
                  <svg
                    width="21"
                    height="19"
                    viewBox="0 0 21 19"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M17.5 0H3.5C2.70435 0 1.94129 0.316071 1.37868 0.87868C0.816071 1.44129 0.5 2.20435 0.5 3V18C0.500305 18.1772 0.547689 18.3511 0.6373 18.504C0.726912 18.6569 0.855534 18.7832 1.01 18.87C1.15946 18.9547 1.32821 18.9995 1.5 19C1.67948 18.9999 1.85564 18.9516 2.01 18.86L6.5 16.14C6.66597 16.0412 6.85699 15.9926 7.05 16H17.5C18.2956 16 19.0587 15.6839 19.6213 15.1213C20.1839 14.5587 20.5 13.7956 20.5 13V3C20.5 2.20435 20.1839 1.44129 19.6213 0.87868C19.0587 0.316071 18.2956 0 17.5 0ZM6.5 9C6.30222 9 6.10888 8.94135 5.94443 8.83147C5.77998 8.72159 5.65181 8.56541 5.57612 8.38268C5.50043 8.19996 5.48063 7.99889 5.51921 7.80491C5.5578 7.61093 5.65304 7.43275 5.79289 7.29289C5.93275 7.15304 6.11093 7.0578 6.30491 7.01921C6.49889 6.98063 6.69996 7.00043 6.88268 7.07612C7.06541 7.15181 7.22159 7.27998 7.33147 7.44443C7.44135 7.60888 7.5 7.80222 7.5 8C7.5 8.26522 7.39464 8.51957 7.20711 8.70711C7.01957 8.89464 6.76522 9 6.5 9ZM10.5 9C10.3022 9 10.1089 8.94135 9.94443 8.83147C9.77998 8.72159 9.65181 8.56541 9.57612 8.38268C9.50043 8.19996 9.48063 7.99889 9.51921 7.80491C9.5578 7.61093 9.65304 7.43275 9.79289 7.29289C9.93275 7.15304 10.1109 7.0578 10.3049 7.01921C10.4989 6.98063 10.7 7.00043 10.8827 7.07612C11.0654 7.15181 11.2216 7.27998 11.3315 7.44443C11.4414 7.60888 11.5 7.80222 11.5 8C11.5 8.26522 11.3946 8.51957 11.2071 8.70711C11.0196 8.89464 10.7652 9 10.5 9ZM14.5 9C14.3022 9 14.1089 8.94135 13.9444 8.83147C13.78 8.72159 13.6518 8.56541 13.5761 8.38268C13.5004 8.19996 13.4806 7.99889 13.5192 7.80491C13.5578 7.61093 13.653 7.43275 13.7929 7.29289C13.9327 7.15304 14.1109 7.0578 14.3049 7.01921C14.4989 6.98063 14.7 7.00043 14.8827 7.07612C15.0654 7.15181 15.2216 7.27998 15.3315 7.44443C15.4414 7.60888 15.5 7.80222 15.5 8C15.5 8.26522 15.3946 8.51957 15.2071 8.70711C15.0196 8.89464 14.7652 9 14.5 9Z"
                      fill="white"
                    />
                  </svg>
                </div>
              </div>

              <div className="text_area_cont" ref={textAreaRef}>
                <h1>Mesaj</h1>
                <textarea
                  name="message"
                  placeholder="Describe your project"
                  required
                ></textarea>
              </div>
            </div>
            <button
              type="submit"
              className="submitBtn"
              disabled={isSending}
              ref={submitRef}
            >
              {isSending ? "Sending..." : "Contact"}
            </button>
            {responseMessage && (
              <p className="response_message">{responseMessage}</p>
            )}
          </form>
        </div>
      </div>
    </div>
  );
};
export default Contact;
